module.exports = __webpack_public_path__ + "img/send-blue.8ec030a2.svg";